module.exports = __webpack_public_path__ + "asset/image-Broom-19eaf77b16bf78f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/Broom.svg
// module id = pz8W
// module chunks = 0